<template>
    <input class="text-input" ref="inputRef" type="text" />
</template>

<script>
import { useCurrencyInput } from "vue-currency-input";

export default {
    name: "MoneyInput",
    props: {
        modelValue: Number,
        options: {
            type: Object,
            default: () => ({}),
        },
        cents: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
    setup(props, { emit }) {
        const defaultOptions = {
            locale: "pt-BR",
            currency: "BRL",
            currencyDisplay: "symbol",
            hideCurrencySymbolOnFocus: false,
            hideGroupingSeparatorOnFocus: false,
            hideNegligibleDecimalDigitsOnFocus: false,
            autoDecimalDigits: true,
            useGrouping: true,
            accountingSign: false,
            ...(props.cents ? { valueScaling: "precision" } : {}),
            ...props.options,
        };

        const { inputRef } = useCurrencyInput(defaultOptions);

        return { inputRef };
    },
};
</script>
